<div class="gracias-container">
  <div class="gracias-icono">
    <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
      <circle cx="32" cy="32" r="32" fill="#4CAF50"/>
      <path d="M20 34l8 8 16-16" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <h2 class="gracias-titulo">¡Gracias por confiar en nosotros!</h2>
  <p class="gracias-subtitulo">Tus datos fueron registrados correctamente.<br>Pronto un asesor se comunicará contigo para ayudarte.</p>
</div>
